import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: () => import('../views/loginPublic/login'),
    meta: {
      title: '登录数译账号', // 动态 Title
      transition: 'out-in'
    }
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/loginPublic/register'),
    meta: {
      title: '注册', // 动态 Title
      transition: 'out-in'
    }
  },
  {
    path: '/forgetPwd',
    name: 'forgetPwd',
    component: () => import('../views/loginPublic/forgetPwd'),
    meta: {
      title: '忘记密码', // 动态 Title
      transition: 'out-in'
    }
  },
  {
    path: '/wxLogin',
    name: 'wxLogin',
    component: () => import('../views/loginPublic/wxLogin'),
    meta: {
      title: '微信登录', // 动态 Title
      transition: 'out-in'
    }
  },
  {
    path: '/oauth/callback',
    name: 'dingTalk',
    component: () => import('../views/oauth/dingTalk.vue'),
    meta: {
      title: '钉钉登录回调', // 动态 Title
      transition: 'out-in'
    }
  },
  {
    path: '*',
    redirect: '/',
    name: '错误路由'
  }
]
// 全局重写addRoutes方法，防止Duplicate named routes definition报错
VueRouter.prototype.$addRoutes = (params) => {
  router.matcher = new VueRouter().matcher
  router.addRoutes(params)
}

const router = new VueRouter({
  routes
})

export default router
